import { Form, Input, Select } from "antd";
import React from "react";
import { BankAccountType_New } from "../../../Services/Vendor/VendorRegistrationService";

interface IFouStepReg {
  index: number;
}
const FourthStepReg = ({ index }: IFouStepReg) => {
  return (
    <>
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <Form.Item
          label="Account Holder Name"
          name={[index, "accountHolderName"]}
          rules={[
            {
              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.]*$/,
              message: "Enter Valid Account Holder Name",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Account Number"
          name={[index, "accountNumber"]}
          rules={[
            {
              pattern: new RegExp(/^\d{6,18}$/),
              message: "Enter Valid Account Number",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Bank Account Type" name={[index, "accountType"]}>
          <Select
            options={[
              {
                label: "All",
                value: BankAccountType_New.All,
              },
              {
                label: "Saving Account",
                value: BankAccountType_New.SavingAccount,
              },
              {
                label: "Current Account",
                value: BankAccountType_New.CurrentAccount,
              },
              {
                label: "Cash Credit Account",
                value: BankAccountType_New.CashCreditAccount,
              },
              {
                label: "Over Draft Account",
                value: BankAccountType_New.OverdraftAccount,
              },
              {
                label: "Credit Card",
                value: BankAccountType_New.CreditCard,
              },
            ]}
          />
        </Form.Item>
        <Form.Item
          label="Bank Name"
          name={[index, "bankName"]}
          rules={[
            {
              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.]*$/,
              message: "Enter Valid Bank Name",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="IFSC Code"
          name={[index, "IFSCCode"]}
          rules={[
            {
              pattern: /^[A-Za-z]{4}[0][0-9]{6}$/,
              message: "Input valid IFSC Code",
            },
            // {
            //   pattern: /^[A-Z]$/,
            //   message: "Enter Capital letters",
            // },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Branch" name={[index, "branch"]}>
          <Input />
        </Form.Item>
        <Form.Item label="UPI Id" name={[index, "UPIId"]}>
          <Input />
        </Form.Item>
      </div>
    </>
  );
};

export default FourthStepReg;
